import { createContext, PropsWithChildren, useCallback, useContext, useRef, useState } from 'react';
import ConfirmDialog from './ConfirmDialog';

//eslint-disable-next-line
type Params = any;

//eslint-disable-next-line
const defaultFunction = (p?: Params) => Promise.resolve(true);

const defaultValue = {
  confirmRef: {
    current: defaultFunction,
  },
};

const ConfirmContext = createContext(defaultValue);

export function ConfirmContextProvider({ children }: PropsWithChildren<unknown>) {
  const confirmRef = useRef(defaultFunction);

  return (
    <ConfirmContext.Provider value={{ confirmRef }}>
      {children}
      <ConfirmDialogWithContext />
    </ConfirmContext.Provider>
  );
}

function ConfirmDialogWithContext() {
  const [open, setOpen] = useState(false);
  const [props, setProps] = useState<Params | undefined>();
  // eslint-disable-next-line
  const resolveRef = useRef((v: boolean) => {});
  const { confirmRef } = useContext(ConfirmContext);

  confirmRef.current = (props) =>
    new Promise((resolve) => {
      setProps(props);
      setOpen(true);
      resolveRef.current = resolve;
    });

  return (
    <ConfirmDialog
      onConfirm={() => {
        resolveRef.current(true);
        setOpen(false);
      }}
      onCancel={() => {
        resolveRef.current(false);
        setOpen(false);
      }}
      open={open}
      {...props}
    />
  );
}

export function useConfirm() {
  const { confirmRef } = useContext(ConfirmContext);
  return {
    confirm: useCallback(
      (p: Params) => {
        return confirmRef.current(p);
      },
      [confirmRef]
    ),
  };
}
